module.exports = __webpack_public_path__ + "img/CRM-No-Todos.7926a935.svg";